import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">Politique de Confidentialité</h1>
          
          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introduction</h2>
              <p className="text-gray-700 mb-4">
                DFPRO SAS, éditeur de la plateforme <strong>fenetreslyon.fr</strong>, accorde une grande importance à la protection de vos données personnelles.
              </p>
              <p className="text-gray-700 mb-4">
                La présente Politique de Confidentialité vous informe sur la manière dont nous collectons, utilisons, partageons et protégeons vos données personnelles, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Responsable du traitement</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Raison sociale :</strong> DFPRO SAS</p>
                <p className="text-gray-700 mb-2"><strong>Siège social :</strong> 123 Avenue de la République, 69003 Lyon, France</p>
                <p className="text-gray-700 mb-2"><strong>Email :</strong> <a href="mailto:info@fenetreslyon.fr" className="text-teal-600 hover:text-teal-700">info@fenetreslyon.fr</a></p>
                <p className="text-gray-700 mb-2"><strong>Téléphone :</strong> <a href="tel:0980803684" className="text-teal-600 hover:text-teal-700">09 80 80 36 84</a></p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Données collectées</h2>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.1. Données collectées directement</h3>
              <p className="text-gray-700 mb-4">
                Lorsque vous utilisez notre plateforme de mise en relation, nous collectons les données suivantes :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li><strong>Identité :</strong> Nom, prénom</li>
                <li><strong>Coordonnées :</strong> Adresse email, numéro de téléphone, adresse postale</li>
                <li><strong>Demande :</strong> Type de service souhaité, description du projet, photos éventuelles</li>
                <li><strong>Communication :</strong> Historique des échanges avec notre service client</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.2. Données collectées automatiquement</h3>
              <p className="text-gray-700 mb-4">
                Lors de votre navigation sur notre site, nous collectons automatiquement :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li><strong>Données de connexion :</strong> Adresse IP, type de navigateur, système d'exploitation</li>
                <li><strong>Données de navigation :</strong> Pages visitées, durée de visite, parcours de navigation</li>
                <li><strong>Cookies :</strong> Identifiants de session, préférences utilisateur (voir section Cookies)</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">3.3. Données sensibles</h3>
              <p className="text-gray-700 mb-4">
                Nous ne collectons <strong>aucune donnée sensible</strong> (origine raciale ou ethnique, opinions politiques, convictions religieuses, données de santé, etc.).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Finalités du traitement</h2>
              <p className="text-gray-700 mb-4">
                Vos données personnelles sont collectées et traitées pour les finalités suivantes :
              </p>
              <div className="bg-gray-50 p-6 rounded-lg space-y-4">
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">4.1. Mise en relation (base légale : exécution du contrat)</h4>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Transmission de votre demande aux artisans partenaires qualifiés</li>
                    <li>Facilitation du contact entre vous et les professionnels</li>
                    <li>Suivi de votre demande</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">4.2. Gestion de la relation client (base légale : intérêt légitime)</h4>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Réponse à vos questions et réclamations</li>
                    <li>Amélioration de nos services</li>
                    <li>Envoi d'informations sur nos services (avec votre consentement)</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">4.3. Statistiques et analyses (base légale : intérêt légitime)</h4>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Analyse de l'utilisation de la plateforme</li>
                    <li>Amélioration de l'expérience utilisateur</li>
                    <li>Mesure de l'audience (Google Analytics)</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-2">4.4. Obligations légales (base légale : obligation légale)</h4>
                  <ul className="list-disc pl-6 space-y-1 text-gray-700">
                    <li>Respect des obligations comptables et fiscales</li>
                    <li>Réponse aux demandes des autorités compétentes</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Partage des données</h2>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.1. Artisans Partenaires</h3>
              <p className="text-gray-700 mb-4">
                <strong>Important :</strong> Vos coordonnées (nom, email, téléphone, description de votre projet) sont <strong>transmises aux artisans partenaires</strong> dans le cadre de votre demande de mise en relation.
              </p>
              <p className="text-gray-700 mb-4">
                En soumettant une demande de devis, vous consentez explicitement à ce partage de données, nécessaire à la mise en relation.
              </p>
              <p className="text-gray-700 mb-4">
                Les artisans partenaires s'engagent à :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>Utiliser vos données uniquement pour vous contacter dans le cadre de votre demande</li>
                <li>Ne pas transmettre vos données à des tiers</li>
                <li>Respecter le RGPD et la confidentialité de vos informations</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.2. Prestataires de services</h3>
              <p className="text-gray-700 mb-4">
                Nous faisons appel à des prestataires de services pour le fonctionnement de notre plateforme :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li><strong>Hébergement :</strong> Vercel Inc. (États-Unis) - Données hébergées de manière sécurisée</li>
                <li><strong>Base de données :</strong> Supabase (conformité RGPD)</li>
                <li><strong>Analyse d'audience :</strong> Google Analytics (données anonymisées)</li>
                <li><strong>Communication :</strong> Services d'envoi d'emails</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Ces prestataires sont soumis à des obligations de confidentialité et ne peuvent utiliser vos données qu'aux fins pour lesquelles nous les leur communiquons.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">5.3. Autorités légales</h3>
              <p className="text-gray-700 mb-4">
                Nous pouvons être amenés à communiquer vos données aux autorités compétentes si la loi l'exige ou pour protéger nos droits.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Durée de conservation</h2>
              <p className="text-gray-700 mb-4">
                Vos données personnelles sont conservées pendant les durées suivantes :
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <ul className="space-y-3 text-gray-700">
                  <li><strong>Demandes de devis :</strong> 3 ans à compter de la dernière interaction</li>
                  <li><strong>Données de navigation :</strong> 13 mois (cookies)</li>
                  <li><strong>Données comptables :</strong> 10 ans (obligation légale)</li>
                  <li><strong>Réclamations :</strong> Durée de la prescription légale applicable</li>
                </ul>
              </div>
              <p className="text-gray-700 mt-4">
                À l'issue de ces délais, vos données sont supprimées ou anonymisées.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Vos droits</h2>
              <p className="text-gray-700 mb-4">
                Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :
              </p>
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit d'accès</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez obtenir une copie de vos données personnelles</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit de rectification</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez corriger vos données inexactes ou incomplètes</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit à l'effacement</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez demander la suppression de vos données (sous certaines conditions)</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit à la limitation</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez demander la limitation du traitement de vos données</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit à la portabilité</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez récupérer vos données dans un format structuré</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit d'opposition</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez vous opposer au traitement de vos données (notamment pour la prospection)</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit de retirer votre consentement</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez retirer votre consentement à tout moment</p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">✓ Droit de définir des directives post-mortem</h4>
                  <p className="text-gray-700 text-sm">Vous pouvez définir le sort de vos données après votre décès</p>
                </div>
              </div>
              <p className="text-gray-700 mt-6 mb-4">
                <strong>Comment exercer vos droits ?</strong>
              </p>
              <p className="text-gray-700 mb-4">
                Pour exercer vos droits, contactez-nous :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>Par email : <a href="mailto:info@fenetreslyon.fr" className="text-teal-600 hover:text-teal-700">info@fenetreslyon.fr</a></li>
                <li>Par courrier : DFPRO SAS - Service Protection des Données, 123 Avenue de la République, 69003 Lyon</li>
              </ul>
              <p className="text-gray-700 mb-4">
                Nous vous répondrons dans un délai d'<strong>1 mois</strong> maximum. Une pièce d'identité pourra vous être demandée pour vérifier votre identité.
              </p>
              <p className="text-gray-700 mb-4">
                <strong>Réclamation auprès de la CNIL :</strong> Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale de l'Informatique et des Libertés (CNIL) : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700">www.cnil.fr</a>
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Sécurité des données</h2>
              <p className="text-gray-700 mb-4">
                Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données personnelles contre :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
                <li>L'accès non autorisé</li>
                <li>La perte, l'altération ou la divulgation accidentelle</li>
                <li>Les cyberattaques</li>
              </ul>
              <p className="text-gray-700 mb-4">
                <strong>Mesures de sécurité :</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Chiffrement des données sensibles (SSL/TLS)</li>
                <li>Authentification sécurisée pour l'accès aux données</li>
                <li>Sauvegardes régulières</li>
                <li>Limitation de l'accès aux données aux seules personnes autorisées</li>
                <li>Sensibilisation de nos équipes à la protection des données</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Cookies</h2>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">9.1. Qu'est-ce qu'un cookie ?</h3>
              <p className="text-gray-700 mb-4">
                Un cookie est un petit fichier texte déposé sur votre terminal lors de la visite d'un site web. Il permet de mémoriser des informations relatives à votre navigation.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">9.2. Cookies utilisés</h3>
              <div className="space-y-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Cookies strictement nécessaires</h4>
                  <p className="text-gray-700 text-sm mb-2">Ces cookies sont indispensables au fonctionnement du site. Ils ne nécessitent pas votre consentement.</p>
                  <ul className="list-disc pl-6 text-sm text-gray-700">
                    <li>Cookies de session</li>
                    <li>Cookies de sécurité</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Cookies de préférences</h4>
                  <p className="text-gray-700 text-sm mb-2">Ces cookies mémorisent vos choix (langue, région, etc.).</p>
                  <ul className="list-disc pl-6 text-sm text-gray-700">
                    <li>Préférences de cookies</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Cookies analytiques (Google Analytics)</h4>
                  <p className="text-gray-700 text-sm mb-2">Ces cookies nous permettent de mesurer l'audience et d'améliorer le site. Ils nécessitent votre consentement.</p>
                  <ul className="list-disc pl-6 text-sm text-gray-700">
                    <li>Google Analytics (GA4) - ID : G-Z8KT1H89GG</li>
                  </ul>
                </div>
              </div>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">9.3. Gestion des cookies</h3>
              <p className="text-gray-700 mb-4">
                Vous pouvez à tout moment modifier vos préférences de cookies via notre bannière de gestion des cookies ou les paramètres de votre navigateur.
              </p>
              <p className="text-gray-700 mb-4">
                <strong>Attention :</strong> Le refus de certains cookies peut limiter l'accès à certaines fonctionnalités du site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Transferts de données hors UE</h2>
              <p className="text-gray-700 mb-4">
                Certains de nos prestataires (notamment Vercel pour l'hébergement) peuvent être situés en dehors de l'Union Européenne.
              </p>
              <p className="text-gray-700 mb-4">
                Dans ce cas, nous nous assurons que des garanties appropriées sont mises en place (clauses contractuelles types de la Commission Européenne, Privacy Shield, etc.) pour protéger vos données.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Mineurs</h2>
              <p className="text-gray-700 mb-4">
                Notre plateforme n'est pas destinée aux mineurs de moins de 18 ans. Nous ne collectons pas sciemment de données personnelles concernant des mineurs.
              </p>
              <p className="text-gray-700 mb-4">
                Si vous êtes parent ou tuteur légal et que vous découvrez que votre enfant nous a fourni des données personnelles, contactez-nous pour que nous puissions les supprimer.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Modifications de la politique</h2>
              <p className="text-gray-700 mb-4">
                Nous nous réservons le droit de modifier la présente Politique de Confidentialité à tout moment. Les modifications entrent en vigueur dès leur publication sur le site.
              </p>
              <p className="text-gray-700 mb-4">
                Nous vous encourageons à consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Contact</h2>
              <p className="text-gray-700 mb-4">
                Pour toute question concernant cette Politique de Confidentialité ou l'exercice de vos droits, contactez-nous :
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Email :</strong> <a href="mailto:info@fenetreslyon.fr" className="text-teal-600 hover:text-teal-700">info@fenetreslyon.fr</a></p>
                <p className="text-gray-700 mb-2"><strong>Téléphone :</strong> <a href="tel:0980803684" className="text-teal-600 hover:text-teal-700">09 80 80 36 84</a></p>
                <p className="text-gray-700"><strong>Courrier :</strong> DFPRO SAS - Service Protection des Données<br />123 Avenue de la République<br />69003 Lyon, France</p>
              </div>
            </section>

            <p className="text-sm text-gray-500 mt-12 pt-8 border-t border-gray-200">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </div>
        </div>
      </div>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      <Footer />
    </div>
  );
}
